import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'
import { ContactDataBase, contactDataBaseConverter, ContactDataTechnical, contactDataTechnicalConverter } from '../contact-box.module'

@Injectable({ providedIn: 'root' })
export class ContactBoxFullConverter extends CmsConverterService<ContactBoxFullData> {
  convertData (source: CmsComponent) {
    const contactData = source?.otherProperties?.formData?.st_contact?.value?.[0]?.otherProperties?.formData ?? {}
    return {
      country: source?.otherProperties?.locale?.country ?? '',
      contactData: {
        ...contactDataBaseConverter(contactData),
        companyPhone: contactData.gc_phone?.value,
        ordersEmail: contactData.gc_orders_email?.value,
        ordersFax: contactData.gc_orders_fax?.value,
        ordersPhone: contactData.gc_orders_phone?.value,
        ...contactDataTechnicalConverter(contactData),
        web: contactData.gc_web?.value
      }
    }
  }
}

export const CONTACT_BOX_FULL_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, ContactBoxFullData>>('ContactBoxFullConverter')

export interface ContactBoxFullData extends ConvertedComponentData {
  country: string;
  contactData: ContactBoxFullContactData;
}

export interface ContactBoxFullContactData extends ContactDataBase, ContactDataTechnical {
  companyPhone: string;
  ordersEmail: string;
  ordersFax: string;
  ordersPhone: string;
  web: string;
}
